import { render } from "./GroupWork.vue?vue&type=template&id=5696f9f7"
import script from "./GroupWork.vue?vue&type=script&lang=js"
export * from "./GroupWork.vue?vue&type=script&lang=js"

import "./GroupWork.vue?vue&type=style&index=0&id=5696f9f7&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__